import Footer from "./Footer";
import Header from "./Header";

const Sqlserver = () => {
  return (
    <div className="container-fluid">
      <Header />
      <div className="container">
        <div className="row border border-dark m-1">
          
          <div className="row text-center m-3">
            <h1>
              <b>
                <u>SQL Server</u>
              </b>
            </h1>
          </div>

          <div className="row m-3">
            <h4>
              SQL (Structured Query Language) is used to perform operations on
              the records stored in the database, such as updating records,
              inserting records, deleting records, creating and modifying
              database tables, views, etc.
            </h4>
          </div>

          <div className="row m-5 h4">
            <fieldset>
              <legend style={{ width: "40%" }}>Topics:</legend>
              <ul>
                <li>Introduction to SQL Server</li>
                <li>RDBMS Concepts</li>
                <li>Database Creation</li>
                <li>Table Creation & Modification</li>
                <li>Data Types</li>
                <li>Constraints</li>
                <li>Insert, Update & Delete</li>
                <li>Select Queries</li>
                <li>Where Clause</li>
                <li>Order By & Group By</li>
                <li>Aggregate Functions</li>
                <li>Joins</li>
                <li>Subqueries</li>
                <li>Views</li>
                <li>Indexes</li>
                <li>Stored Procedures</li>
                <li>Triggers</li>
                <li>Transactions</li>
                <li>Functions</li>
                <li>Backup & Restore</li>
              </ul>
            </fieldset>
          </div>

          <div className="row m-5">
            <h2>
              <b>Certificate:</b>
            </h2>
            <h2>
              <p>Database (SQL Server)</p>
            </h2>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Sqlserver;
